
export default {
  props: {
    text: String,
    description: String,
  },
};
